import { Box, Chip } from "@mui/material";
import { Fragment, useState } from "react";
import tagEntitiesAPI from "../../_api/_tagEntitiesAPI";
import ColorModal from "./ColorModal";
import tagsAPI from "../../_api/_tagsAPI";
import { toastError } from "../../_utils/toastError";
import AddIcon from "@mui/icons-material/Add";
import EditTagModal from "../EditTagModal";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

const NewTagList = ({
  tagEntities,
  removeTagEntity,
  updateTagColor,
  personId,
  needModal,
  workId,
  setTagEntities,
}: any) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [colorState, setColorState] = useState<any>("#708CFF");
  const [thisTag, setThisTag] = useState<any>();
  const [openAddModal, setOpenAddModal] = useState(false);

  const { t } = useTranslation("common");

  const isValidColor = (color: string) => {
    return color && color.startsWith("#");
  };

  const handleDeleteTag = async (tag: string) => {
    const parts = tag.split("/api/tag_entities/");
    const tagEntity = parts[1];

    if (tagEntity) {
      try {
        await tagEntitiesAPI.delete(tagEntity);
        removeTagEntity(tag);
      } catch (error) {
        toastError();
        console.error("Erreur lors de la suppression du tag:", error);
      }
    }
  };

  const handleModal = (event: any, tag: any) => {
    event.stopPropagation();
    setOpenModal(true);
    setThisTag(tag);
  };

  const handleSaveColor = async (tag: any) => {
    try {
      await tagsAPI.put(tag.tag.id, {
        color: colorState,
      });
      updateTagColor(tag.tag.id, colorState);
    } catch (err) {
      toastError();
    }

    setOpenModal(false);
  };

  return (
    <div>
      <Box>
        <Box
          display="flex"
          alignItems="center"
          flexWrap="wrap"
          justifyContent={needModal === true ? "flex-end" : ""}
        >
          <Fragment
          // style={{ justifyContent: "right", alignItems: "baseline" }}
          >
            {tagEntities?.map((tagEntity: any, index: number) => (
              <Chip
                key={index}
                label={tagEntity.tag.label}
                sx={{
                  m: 0.5,
                  fontSize: "14px",
                  height: "28px",
                  backgroundColor: isValidColor(tagEntity?.tag?.color)
                    ? `${tagEntity?.tag?.color}CC`
                    : "rgba(112, 140, 255, 0.5)",
                  "&:hover": {
                    backgroundColor: isValidColor(tagEntity?.tag?.color)
                      ? tagEntity?.tag?.color
                      : "rgba(112, 140, 255, 1)",
                  },
                }}
                deleteIcon={<ClearIcon fontSize="small" />}
                onDelete={() => handleDeleteTag(tagEntity["@id"])}
                onClick={(e: any) => handleModal(e, tagEntity)}
              />
            ))}
          </Fragment>

          <Chip
            label={
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  m: 0,
                  cursor: "pointer",
                }}
              >
                {t("common_advisor.actions.add")}
                <AddIcon fontSize="small" sx={{ marginLeft: "2px" }} />
              </Box>
            }
            sx={{
              m: 0.5,
              fontSize: "14px",
              height: "28px",
              backgroundColor: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#E6E6E6",
              },
            }}
            onClick={(e: any) => setOpenAddModal(true)}
          />
        </Box>

        <ColorModal
          open={openModal}
          close={() => setOpenModal(false)}
          colorState={colorState}
          setColorState={setColorState}
          thisTag={thisTag}
          handleSaveColor={handleSaveColor}
        />
        <EditTagModal
          open={openAddModal}
          close={() => setOpenAddModal(false)}
          tagEntities={tagEntities}
          isValidColor={isValidColor}
          handleDeleteTag={handleDeleteTag}
          handleModal={handleModal}
          workId={workId}
          personId={personId}
          type="person"
          setTagEntities={setTagEntities}
        />
      </Box>
    </div>
  );
};

export default NewTagList;
